import { render, staticRenderFns } from "./receipt-discount.vue?vue&type=template&id=ac381734&"
import script from "./receipt-discount.vue?vue&type=script&lang=js&"
export * from "./receipt-discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac381734')) {
      api.createRecord('ac381734', component.options)
    } else {
      api.reload('ac381734', component.options)
    }
    module.hot.accept("./receipt-discount.vue?vue&type=template&id=ac381734&", function () {
      api.rerender('ac381734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/receipt-discount.vue"
export default component.exports